import React, {memo} from 'react';
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from './header.module.scss';
import Logo from "../Logo";

const Header = ({ onContacts, onLogo }) => {
  const [t] = useTranslation("global");

  return (
    <header className={styles.wrapper}>
      <div className={`container-fluid ${styles.container}`}>
        <div className={`${styles.menu}`}>
          <nav className={styles.navigation}>
            <NavLink className={({ isActive }) => (isActive ? `${styles.navLink} ${styles.navActive}` : `${styles.navLink}`)} to={'/games'}>{t("menu.games")}</NavLink>
            <NavLink className={({ isActive }) => (isActive ? `${styles.navLink} ${styles.navActive}` : `${styles.navLink}`)} to={'/jobs'}>{t("menu.jobs")}</NavLink>

            <Link onClick={(e) => onLogo(e)} className={styles.logo} to={'/'}>
              <Logo />
            </Link>

            <NavLink className={({ isActive }) => (isActive ? `${styles.navLink} ${styles.navActive}` : `${styles.navLink}`)} to={'/about'}>{t("menu.about")}</NavLink>
            <Link className={styles.navLink} onClick={(e) => onContacts(e)}>{t("menu.contact")}</Link>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default memo(Header);